var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2069 3.5861L9.41438 0.792974C9.32152 0.700091 9.21127 0.626411 9.08993 0.576142C8.96859 0.525873 8.83853 0.5 8.70719 0.5C8.57585 0.5 8.4458 0.525873 8.32446 0.576142C8.20312 0.626411 8.09287 0.700091 8 0.792974L0.29313 8.50047C0.199867 8.593 0.125926 8.70313 0.0756045 8.82448C0.025283 8.94584 -0.000414649 9.07598 5.05934e-06 9.20735V12.0005C5.05934e-06 12.2657 0.105362 12.52 0.292898 12.7076C0.480435 12.8951 0.734789 13.0005 1.00001 13.0005H3.79313C3.9245 13.0009 4.05464 12.9752 4.17599 12.9249C4.29735 12.8746 4.40748 12.8006 4.50001 12.7073L12.2069 5.00047C12.2998 4.90761 12.3734 4.79736 12.4237 4.67602C12.474 4.55468 12.4999 4.42463 12.4999 4.29329C12.4999 4.16195 12.474 4.03189 12.4237 3.91055C12.3734 3.78921 12.2998 3.67896 12.2069 3.5861ZM3.79313 12.0005H1.00001V9.20735L6.50001 3.70735L9.29313 6.50047L3.79313 12.0005ZM10 5.79297L7.20688 3.00047L8.70688 1.50047L11.5 4.29297L10 5.79297Z",
    fill: "#31333F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditOutline);
export default __webpack_public_path__ + "static/media/edit-outline.03a631e7e672abcc31e90800caadd0a2.svg";
export { ForwardRef as ReactComponent };